import { render, staticRenderFns } from "./CouponVipPopupCommon.vue?vue&type=template&id=2c8bf4c0&scoped=true&"
import script from "./CouponVipPopupCommon.vue?vue&type=script&lang=js&"
export * from "./CouponVipPopupCommon.vue?vue&type=script&lang=js&"
import style0 from "./CouponVipPopupCommon.vue?vue&type=style&index=0&id=2c8bf4c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8bf4c0",
  null
  
)

export default component.exports